<template lang="pug">
  .w-100
    p.col.text-right.mb-2(v-if="document_id")
      | {{t("sofia.tirantcloud.document_editor")}}
      a.btn.btn-link.m-0.p-0(
        target="_blank"
        rel="noopener noreferrer"
        :href="url_for_rails_documento_show(document_id)"
      )
        |  {{docids_prefix}}{{document_id}}
    #tirantcloud-container(v-once)
    modal-quick-view-vue(
      :bus="quickViewBus"
      :copy-buttons-visible="true"
    )
    modal-links-vue(
      ref="links_modal"
      @links-single-document-found="onSingleDocumentFound"
    )
    sofia-filter-modals-vue(
      ref="sofia-filter-modals"
      @confirm_filter_values="confirmFilterValues"
      :sofia-filters="sofiaFilters"
    )
</template>

<script>
import Vue from 'vue'
import mixins from 'common/mixins'
import tirantCloud from 'common/mixins/tirantcloud'

export default {
  name: 'tirant-cloud-wrapper-vue',
  props: {
    path: { type: String, default: "" },
  },
  mixins: [mixins.requests, mixins.translate, tirantCloud],
  components: {
    'modal-quick-view-vue': () => import(/* webpackChunkName: "[request]" */ 'components/ModalQuickView'),
    'modal-links-vue': () => import(/* webpackChunkName: "[request]" */ 'components/ModalLinks'),
  },
  data() {
    return {
      quickViewBus: new Vue(),
      show_document_link: false,
      show_new_document_menu: false,
      document_id: "",
      saveStatusVisible: true,
      documentTitleVisible: true
    }
  },
  computed: {
    folder_path() { return this.user_path },
    modalLinksRef() {
      // sometimes refs is an array with a single element
      return Array.isArray(this.$refs.links_modal) ? this.$refs.links_modal[0] : this.$refs.links_modal
    }
  },
  methods: {
    show_document(documentIds, documentType) {
      if (!documentIds) return
      if (typeof documentIds === 'string') {
        documentIds = documentIds.split(';')
      }

      if (documentIds.length > 1) {
        this.modalLinksRef.load_links(documentIds)
      } else {
        this.quickViewBus.$emit('quick_view:show_document', documentIds[0], documentType)
      }
    },
    on_document_metadata_changed(metadata = {}) {
      if(metadata.document_id !== undefined) {
          this.http_get({
            url: this.url_for_rails_documento_show(metadata.document_id),
            success: (response) => {
              if(response.status == 200)
                this.document_id = metadata.document_id
            }
          })
      } else {
        this.document_id = ""
      }
    },
    onSingleDocumentFound({ documentId }) {
      this.modalLinksRef.reset_modal()
      this.quickViewBus.$emit('quick_view:show_document', String(documentId), '')
    }
  },
  async mounted() {
    await this.tirantCloud.init()
    this.tirantCloud.generateFileList({
      selector: 'tirantcloud-container',
      title: this.t('components.tirantcloud.file_list.title'),
      rootPath: this.user_path,
      path: this.user_path,
      onSofiaLinkClick: this.show_document,
      onDocumentMetadataChanged: this.on_document_metadata_changed,
      redirectPath: this.path,
      showNewDocumentMenu: this.show_new_document_menu
    })
  }
}
</script>
